import React, { useState } from 'react'
import './add-edit-product.scss'
import NormalInput from '../../common/inputs/NormalInput'
import { BiLoaderAlt } from 'react-icons/bi'
import { wholeAxios } from '../../../config/axios'
import toast from 'react-hot-toast'
import RadioInput from '../../common/inputs/RadioInput'
import { TbX } from 'react-icons/tb'

const AddEditProduct = ({ product, setData, setModal }) => {
    const [form, setForm] = useState(product || {})
    const [loading, setLoading] = useState('')
    const [skuList, setSkuList] = useState(product?.variant_list || [])
    const [skuInput, setSkuInput] = useState('')

    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value
        })
    }

    const handleChangeStatus = (e, type) => {
        if (e.target.value === 'true') {
            setForm({
                ...form,
                [type]: null
            })
        } else {
            setForm({
                ...form,
                [type]: new Date()
            })
        }
    }

    const handleAddSku = () => {
        if (!skuInput) {
            return;
        }

        setSkuList((state) => [...state, skuInput])

        setSkuInput('')
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading('submit')
        if (product) {
            wholeAxios.put('/products', { ...form, sku_list: skuList || [] })
                .then(() => {
                    setData((state) => state.map((obj) => {
                        if (obj._id === form._id) {
                            return { ...form, variant_list: skuList }
                        }
                        return obj
                    }))
                    setLoading('')
                    setModal({ status: false })
                    toast.success('Updated')
                })
                .catch((error) => {
                    setLoading('')
                    toast.error(error.message)
                })
        } else {
            wholeAxios.post('/products', { ...form, sku_list: skuList || [] })
                .then((response) => {
                    setData((state) => [response.data, ...state])
                    setLoading('')
                    setModal({ status: false })
                })
                .catch((error) => {
                    setLoading('')
                    toast.error(error.message)
                })
        }

    }


    return (
        <div className="add-edit-vessel-product-div">
            <form action="" onSubmit={handleSubmit}>
                <div className="form-main-content">
                    <NormalInput label='Product name' type={'text'} name='product_name' value={form.product_name || ''} onChangeFun={handleChange} />
                    <NormalInput label='Price (₹)' type={'number'} name='price' value={form.price || ''} onChangeFun={handleChange}
                        min={0} step={'0.01'} />
                    <h5>Variants</h5>
                    <div className="sku-list">
                        {skuList?.map((s, i) => <div className="sku-item" key={i}>
                            <p>{s}</p>
                            <TbX onClick={() => setSkuList(skuList?.filter(k => k !== s))} />
                        </div>)}
                    </div>
                    <div className="sku-div">
                        <NormalInput label='Enter Variant SKU' name='sku' value={skuInput || ''} onChangeFun={(e) => setSkuInput(e.target.value)}
                            isRequired={false} />
                        <button type='button' onClick={handleAddSku}>Add</button>
                    </div>

                    {product && <>
                        <div className="radio-group-div">
                            <p>Sales Status</p>
                            <div>
                                <RadioInput name={'sales_inactive'} label={'Active'} checked={!form.sales_inactive} value={'true'}
                                    onChangeFun={(e) => handleChangeStatus(e, 'sales_inactive')} />
                                <RadioInput name={'sales_inactive'} label={'Inactive'} checked={form.sales_inactive} value={'false'}
                                    onChangeFun={(e) => handleChangeStatus(e, 'sales_inactive')} />
                            </div>
                        </div>
                        <div className="radio-group-div">
                            <p>Service Status</p>
                            <div>
                                <RadioInput name={'service_inactive'} label={'Active'} checked={!form.service_inactive} value={'true'}
                                    onChangeFun={(e) => handleChangeStatus(e, 'service_inactive')} />
                                <RadioInput name={'service_inactive'} label={'Inactive'} checked={form.service_inactive} value={'false'}
                                    onChangeFun={(e) => handleChangeStatus(e, 'service_inactive')} />
                            </div>
                        </div>
                    </>}
                </div>
                <div className="button-div">
                    <button>{loading ? <span className='loading-icon'><BiLoaderAlt /></span> : product ? 'Update' : 'Create'}</button>
                </div>
            </form>
        </div>
    )
}

export default AddEditProduct